/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMailOpened = createReactComponent("outline", "mail-opened", "IconMailOpened", [["path", { "d": "M3 9l9 6l9 -6l-9 -6l-9 6", "key": "svg-0" }], ["path", { "d": "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10", "key": "svg-1" }], ["path", { "d": "M3 19l6 -6", "key": "svg-2" }], ["path", { "d": "M15 13l6 6", "key": "svg-3" }]]);

export { IconMailOpened as default };
//# sourceMappingURL=IconMailOpened.mjs.map
